export const BPDA: MapGeoJsonData = {
  type: "FeatureCollection",
  features: [
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.07772, 42.2912906],
      },
      properties: {
        Address: "25 New England Avenue",
        "Submission Title": "25 New England Avenue",
        Name: "n/a",
        Link:
          "http://www.bostonplans.org/projects/development-projects/25-new-england-avenue",
        Description:
          "Codman Square Neighborhood Development Corporation proposes the construction of 23 affordable rental units with 12 parking spaces at 25 New England Avenue in the Codman Square Neighborhood of Dorchester.",
        Image: "assets/images/19001-New-England-Ave_ARTICLE-80-DRAWINGS.jpg",
        Status: "Board Approved",
        Units: 23,
        "Market Rate": null,
        Affordable: 23,
        Rent: "23",
        Own: "",
        Parking: 12,
        Stories: 4,
        "Height (ft)": 42,
        Notes: "",
        "Community edit?": "",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.08455304, 42.28133411],
      },
      properties: {
        Address: "872 Morton Street",
        "Submission Title": "Morton Station Village",
        Name: "Morton Station Village",
        Link:
          "http://www.bostonplans.org/projects/development-projects/morton-station-village",
        Description:
          "Morton Station Village is a new construction development consisting of 40 units of mixed-income affordable and workforce housing, of which thirty-one (31) units will be rental units for households with incomes of 30% AMI to 100% AMI and nine (9) units will be deed-restricted affordable condominium units for households with incomes of 80% AMI to 100% AMI. The Proposed Development will be adjacent to the Steven P. Odom Serenity Garden.",
        Image:
          "assets/images/Morton-Station-Village-Small-Project-Review-Application-9-5.jpg",
        Status: "Board Approved",
        Units: 40,
        "Market Rate": null,
        Affordable: null,
        Rent: "31",
        Own: "9",
        Parking: 30,
        Stories: 4,
        "Height (ft)": 54,
        Notes: "",
        "Community edit?": "",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.0901194, 42.28903392],
      },
      properties: {
        Address: "1047-1051 Blue Hill Avenue",
        "Submission Title": "Brookview House II",
        Name: "Brookview House II",
        Link:
          "http://www.bostonplans.org/projects/development-projects/brookview-house-ii",
        Description:
          "proposing to develop sixteen (16) units of permanent affordable rental housing for homeless families with supportive services.",
        Image: "",
        Status: "Under Construction",
        Units: 16,
        "Market Rate": null,
        Affordable: 16,
        Rent: "16",
        Own: "",
        Parking: null,
        Stories: null,
        "Height (ft)": null,
        Notes: "Extremely low income",
        "Community edit?": "",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.09145625, 42.28850232],
      },
      properties: {
        Address: "35 Hansborough Street",
        "Submission Title": "Brookview House III",
        Name: "Brookview House III",
        Link:
          "https://courbanize.com/projects/dnd-brookview-house-iii/information",
        Description:
          "a low-income, three-story building with twelve (12) residential rental units, program space and two (2) on-site/off-street parking spaces. Project in conjunction with the City of Boston Department of Neighborhood Development.",
        Image: "assets/images/Brookview_House_III.png",
        Status: "Construction Complete",
        Units: 12,
        "Market Rate": null,
        Affordable: 12,
        Rent: "12",
        Own: "",
        Parking: 2,
        Stories: null,
        "Height (ft)": null,
        Notes: "Extremely low income",
        "Community edit?": "",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.0690698, 42.2767857],
      },
      properties: {
        Address: "1120-1132 Washington Street",
        "Submission Title": "1120-1132 Washington Street",
        Name: "n/a",
        Link:
          "http://www.bostonplans.org/projects/development-projects/1120-1132-washington-street",
        Description:
          "Old Molloy Funeral home in Lower Mills. 57 units proposed, to be determined if condos or rentals",
        Image: "assets/images/1120-1132-Washington-Street.jpg",
        Status: "Under Review",
        Units: 57,
        "Market Rate": 50,
        Affordable: 7,
        Rent: "TBD",
        Own: "TBD",
        Parking: 94,
        Stories: 4,
        "Height (ft)": 40,
        Notes: "in Dorchester ",
        "Community edit?": "",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.09164692, 42.28361364],
      },
      properties: {
        Address: "1199-1203 Blue Hill Avenue",
        "Submission Title": "1199-1203 Blue Hill Avenue",
        Name: "n/a",
        Link:
          "http://www.bostonplans.org/projects/development-projects/1199-1203-blue-hill-avenue",
        Description:
          "A mixed use and commercial development, in which the preliminary unit breakdown is sixteen (16) one-bedroom units and sixteen (16) two-bedroom units.",
        Image: "assets/images/2019-07-22_-1199-1203-Blue-Hill-Ave.jpg",
        Status: "Under Review",
        Units: 32,
        "Market Rate": 28,
        Affordable: 4,
        Rent: "32",
        Own: "",
        Parking: 32,
        Stories: 5,
        "Height (ft)": 58,
        Notes: "",
        "Community edit?": "yes ",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.09065851, 42.2713417],
      },
      properties: {
        Address: "150 River Street",
        "Submission Title": "150 River Street",
        Name: "n/a",
        Link:
          "http://www.bostonplans.org/projects/development-projects/150-river-street",
        Description:
          "The proposed project consists of an elderly affordable rental complex, along with a publicly accessible shade garden, multi-season screened porch, and indoor community room, living room common area, and laundry.",
        Image: "assets/images/2019-09-27_150-River-Street_SPRA.png",
        Status: "Board Approved",
        Units: 30,
        "Market Rate": null,
        Affordable: 30,
        Rent: "30",
        Own: "",
        Parking: 12,
        Stories: 3,
        "Height (ft)": 42,
        Notes: "Elderly affordable",
        "Community edit?": "",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.09065851, 42.26940973],
      },
      properties: {
        Address: "422 River Street",
        "Submission Title": "422 River Street",
        Name: "n/a",
        Link:
          "http://www.bostonplans.org/projects/development-projects/422-river-street",
        Description:
          "Proposal calls for 27 rental units and off-street parking for 22 vehicles.",
        Image: "assets/images/b8ed8a9e019a8e84cc73788096ce1e45-cc_ft_384.jpg",
        Status: "Construction Complete",
        Units: 27,
        "Market Rate": 23,
        Affordable: 4,
        Rent: "27",
        Own: "",
        Parking: 22,
        Stories: 4,
        "Height (ft)": null,
        Notes: "",
        "Community edit?": "yes",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.09265894, 42.26800181],
      },
      properties: {
        Address: "500 River Street",
        "Submission Title": "500 River Street",
        Name: "Mattapan Station",
        Link: "https://mattapanstation.org/",
        Description:
          "The proposed program for this $57 Million project involves the construction of 135 units of mixed-income rental apartment housing in Building 1, along with 10,000 square feet of commercial/retail space, and a 2,000 square foot community room on the ground floor. The development program also includes the future construction of a second building comprised of 9 homeownership units. In total, the proposed Project comprises 165,750 gross square feet (inclusive of residential floors.) This innovative transit-oriented development project will provide critically needed affordable and market-rate housing in the Mattapan community. Just as importantly, residents of the complex will have a variety of transportation options, including public trainsit, ride-share, and bike-share, along with direct access to the Neponset River Greenway, which will substantially enhance their quality of life with the provision of passive and active recreational opportunities.",
        Image: "assets/images/Mattapan-Rendering-2.png",
        Status: "Board Approved",
        Units: 144,
        "Market Rate": 76,
        Affordable: 68,
        Rent: "135",
        Own: "9",
        Parking: 70,
        Stories: 4,
        "Height (ft)": 44,
        Notes: "POAH/Nuestra Comunidad",
        "Community edit?": "",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.09597434, 42.2708886],
      },
      properties: {
        Address: "30-32 Regis Road",
        "Submission Title": "Cote Village",
        Name: "Cote Village",
        Link:
          "http://www.bostonplans.org/projects/development-projects/cote-village",
        Description:
          "Construct 76 units with rental office and community room, 4,172 SF of ground-floor commercial space, including a 12,000 SF public plaza with a total of 84 parking spaces.",
        Image: "assets/images/Cote-Village-Building-A-Cummins-Hwy-view-(1).jpg",
        Status: "Board Approved",
        Units: 76,
        "Market Rate": 8,
        Affordable: 68,
        Rent: "",
        Own: "",
        Parking: 84,
        Stories: null,
        "Height (ft)": null,
        Notes: "Caribbean Integration CDC/POAH",
        "Community edit?": "",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.09296934, 42.28065784],
      },
      properties: {
        Address: "1297-1305 Blue Hill Ave.",
        "Submission Title": "Wellington at 1301",
        Name: "Wellington at 1301",
        Link:
          "http://www.bostonplans.org/projects/development-projects/wellington-at-1301",
        Description:
          "Proposed: the construction of a new five (5)-story, mixed-use building comprised of thirty-nine (39) residential units, a residential lobby, and three (3) ground-floor retail/commercial spaces. Interior, at-grade parking for forty (40) vehicles is provided via access from Blue Hill Avenue, with forty (40) secure bicycle storage spaces also available in the garage area. The Proposed Project totals approximately 42,595 gross square feet.",
        Image: "assets/images/Wellington-at-1301-Rendering.jpg",
        Status: "Board Approved",
        Units: 39,
        "Market Rate": 34,
        Affordable: 5,
        Rent: "",
        Own: "",
        Parking: 40,
        Stories: 5,
        "Height (ft)": 61.5,
        Notes: "",
        "Community edit?": "yes",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.08858823, 42.28348167],
      },
      properties: {
        Address: "767-771 Morton Street",
        "Submission Title": "775 Morton Street",
        Name: "775 Morton Street",
        Link:
          "http://www.bostonplans.org/projects/development-projects/775-morton-street",
        Description:
          "A proposed project that consists of a new four (4)‐story, 27-unit, rental residential building (including 4 income restricted units), with off-street parking for 29 total vehicles.",
        Image: "assets/images/775-Morton-Street.png",
        Status: "Board Approved",
        Units: 27,
        "Market Rate": 23,
        Affordable: 4,
        Rent: "27",
        Own: "",
        Parking: 29,
        Stories: 4,
        "Height (ft)": 44,
        Notes: "",
        "Community edit?": "",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.09423364, 42.28760209],
      },
      properties: {
        Address: "591 Morton Street",
        "Submission Title": "Olmsted Green Phase III",
        Name: "Olmsted Green Phase III",
        Link: "https://www.olmstedgreen.com/olmsted-green-overview",
        Description:
          "Olmsted Green is a 42 Acre Community\nThe Development Timeline is a Long Term, Phased development residential development community transforming former Boston State Hospital site into vibrant mixed-income community\n298 Apartment Homes for Rent\n140 Condominium Homes for Purchase\n3,000 Square Foot Community Center with Indoor & Outdoor Amenities\nOver 15 acres of Planned Greenspace, Walking Paths and Landscaped Grounds",
        Image:
          "assets/images/aHR0cHM6Ly9zMy5hbWF6b25hd3MuY29tL2J1aWxkZXJjbG91ZC8yMmQ1NDVjZDk3MmI5MzAzMmU0ZTk1ODIxNjY1NDA4Ny5qcGVn.jpeg",
        Status: "Construction Complete",
        Units: 268,
        "Market Rate": null,
        Affordable: null,
        Rent: "147",
        Own: "268",
        Parking: null,
        Stories: null,
        "Height (ft)": null,
        Notes: "New Boston Fund / Lena Park CDC",
        "Community edit?": "",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.09388389, 42.27399339],
      },
      properties: {
        Address: "1471 Blue Hill Avenue",
        "Submission Title": "1471 Blue Hill Avenue",
        Name: "n/a",
        Link: "https://www.ttarch.com/1471-blue-hill-ave",
        Description:
          "This mixed use development located along the MBTA commuter line at Blue Hill Avenue Station is proposing 34 residential units in addition to 2,500 square feet of ground level commericial space in Mattapan, MA. The growing area and popular intersection along Blue Hill Avenue contains a diversity of uses and demographics. The projects helps bridge the architectural language of the area while providing much needed housing and commercial space. The building itself creates a social urban space at the streetcorner while residential units clad in a variety of metal, wood and brick help merge the new construction into the exisitng residential fabric.",
        Image: "assets/images/TTArch_1471Hero_003_web.jpg",
        Status: "Not Submitted",
        Units: 34,
        "Market Rate": 30,
        Affordable: 4,
        Rent: "34",
        Own: "",
        Parking: 28,
        Stories: 4,
        "Height (ft)": null,
        Notes: "can't find on bpda",
        "Community edit?": "",
      },
    },
    {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [-71.08172485, 42.30396943],
      },
      properties: {
        Address: "61 Columbia Road",
        "Submission Title": "61 Columbia Road",
        Name: "n/a",
        Link:
          "http://www.bostonplans.org/projects/development-projects/61-columbia-road",
        Description:
          "The proposed project is mixed use, consisting of a 200+ seat auditorium, institutional support spaces, 45 residential studio units (55+, compact living, 6 affordable units), and 32 covered parking spaces. The Owner/Developer is the Massachusetts Association of Minority Law Enforcement Officers (MAMLEO) who is seeking to create a community-focused building in support of its mission. The building use envisions continued community services within assembly spaces, services to MAMLEO membership (gym, offices, meeting rooms), and 55+ housing to support the organization.",
        Image:
          "assets/images/2021-03-18_Small-Project-Review-Application-(SPRA)_61-Columbia-Road.jpg",
        Status: "Under Review",
        Units: null,
        "Market Rate": null,
        Affordable: null,
        Rent: "",
        Own: "",
        Parking: null,
        Stories: null,
        "Height (ft)": null,
        Notes: "",
        "Community edit?": "",
      },
    },
  ],
};

export default BPDA;
